// extracted by mini-css-extract-plugin
export default {"p":"_8420136004 _97fa5d172d _0599d5df5e","clr":"ac88ac792b","dls":"_1f25aeb63b"};